<template>
	<div>
		<template-base class="containerCard">
			<div>
				<div class="mb-2">
					<div class="filter-wrap">
						<section>
							<Filters
								:showFiltersForm="showFiltersForm"
								:showOptionsfilter="[
									'customer',
									'initial_date',
									'end_date',
									'rapid_filters'
								]"
								@clickSearch="setFilterSearch"
								@clickClose="closeFilters"
								:expandedAdvancedFilters="false"
								:optionsCustomer="optionsCustomer"
							/>
						</section>
						<div
							class="filter"
							v-bind:class="[showFiltersForm ? 'filter-active' : '']"
							@click="filterDropDownActive"
							title="Alterar Filtros"
						>
							<FilterIcon/>
						</div>
						<b-dropdown no-caret left variant="link" class="p0 container-modal-btn-print" title="Imprimir" v-if="possuiPermissao('REL_V_CONTAS')">
							<template #button-content>
								<printer-icon class="icon-print filter" />
							</template>
							<b-dropdown-item @click="exportData('csv')">CSV</b-dropdown-item>
							<b-dropdown-item @click="exportData('xlsx')">EXCEL</b-dropdown-item>
							<b-dropdown-item @click="exportData('pdf')">PDF</b-dropdown-item>
						</b-dropdown>
					</div>
				</div>
				<div v-if="linhas.length" class="head-row mb-2 width-pagination-items mt-1">
					<div class="text-head-row width-pagination">
						<label class="text-head-row ml-0">
							Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + (linhas.length) }} de {{ pagination.count }}
						</label>
						<b-pagination
							class="mr-0 mb-2 ml-3"
							id="page"
							v-model="currentPage"
							:total-rows="pagination.count"
							:per-page="pagination.limit.value"
						></b-pagination>
					</div>
					<b-form
						class="text-head-row width-pagination">
						<label class="text-head-row ml-0 w-60">
							Itens por página
						</label>
						<b-form-select
							class="mr-0 mb-2"
							v-model="pagination.limit.value"
							name="itens-por-pagina"
							:options="optionsItensPorPag"
							@input="changeItensByPage()"
							:disabled="loading"
						/>
					</b-form>
				</div>
			</div>
			<div v-if="loading || linhas.length" class="table-responsive">
				<DataTable
					class="data-table"
					:loading="loading"
					:colunas="colunas"
					:linhas="linhas"
					:errMsg="errMsg"
					:nosearch="true"
					:nofilters="true"
					name="customer"
					:hasPagination="true"
					:noedit="true"
					:acoes="false"
					:details="false"
					:alignColumns="alignColumnsTable"
					@clickSortTableBy="(v) => sortTableBy(v)"
					:state="{
						sortBy: sortTable.sortBy,
						sortAsc: sortTable.order === 1,
						query: ''
					}"
					:async="true"
				/>
			</div>
			<div v-else class="alert alert-warning" role="alert">
				{{ errMsg }}
			</div>
		</template-base>
		<vue-html2pdf
			:show-layout="false"
			:enable-download="true"
			:preview-modal="false"

			:html-to-pdf-options="htmlToPdfOptions"
			ref="html2Pdf"
			:float-layout="floatLayout"
			:manual-pagination="true"
			@hasDownloaded="finishGeneratePdf"
		>
			<section slot="pdf-content">
				<ReportPDF
					:title="title"
					:rows="rowsReport"
					:headerData="headerData"
					:fields="fields"
					:showLogo="true"
					:rowsPerPage="Number(22)"
					:fontSizeReport="'13'"
					:widthPage="'210mm'"
					:adjustHeightPage="Number(-5.7)"
					:filterData="filtersSearch"
					:filtersKeys="filtersActived(filtersSearch)"
				/>
			</section>
		</vue-html2pdf>
	</div>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";
	import { possuiPermissao } from "@/helpers/permissions";
	import { CustomerService } from "@/services/customer";
	import * as XLSX from "xlsx";
	import VueHtml2pdf from "vue-html2pdf";
	import ReportPDF from "../ReportToPDF";
	import { mapState } from "vuex";
	import Filters from "@/components/Transactions/Filters.vue";
	import { numberFormatted, exportCSVFile, formatterSimple } from "@/helpers/common";
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { STATUS_RECEIVE } from "@/helpers//enums";
	import { filtersActived } from "@/helpers/filters";

	export default {
		components: {
			TemplateBase,
			DataTable,
			VueHtml2pdf,
			ReportPDF,
			Filters
		},

		data () {
			return {
				ptBR,
				optionsCustomer: [],
				title: "",
				linhas: [],
				loading: true,
				customerService: new CustomerService(),
				errMsg: "Não foi obtida nenhuma informação!",
				colunas: [
					{ value: "Cliente", sortable: true },
					{ value: "CPF/CNPJ", sortable: true },
					{ value: "Documento", sortable: false },
					{ value: "Data", sortable: false },
					{ value: "Vence", sortable: false },
					{ value: "Valor", sortable: false },
					{ value: "Recebido", sortable: false },
					{ value: "Saldo Pendente", sortable: false },
					{ value: "Status", sortable: false }
				],
				alignColumnsTable: [
					"left",
					"left",
					"left",
					"center",
					"center",
					"right",
					"right",
					"right",
					"left"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 25
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				fields : [],
				headerData: {},
				rowsReport: [],
				sortTable: {
					sortBy: 1,
					order: 1
				},
				hideHeaderModal: true,
				isLoading: true,
				showFiltersForm: false,
				floatLayout: true,
				isMobile: false,
				filtersSearch: {},
				totalAmount: 0,
				totalReceivedAmount: 0,
				userName: "",
				loadPDF: false,
				responseResult: {},
				filtersActived
			};
		},

		computed: {
			htmlToPdfOptions () {
				return {
					margin: [0, 0, 0, 0],
					image: {
						type: "jpeg",
						quality: 0.98
					},
					enableLinks: false,
					filename: `${this.title}.pdf`,
					html2canvas: {
						scale: 2,
						useCORS: true
					},

					jsPDF: {
						unit: "mm",
						format: "a4",
						orientation: "portrait",
						floatPrecision: 16
					}
				};
			},
			...mapState(["customer"])
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		async mounted () {
			if (!possuiPermissao("GER_V_VENDA")) {
				return this.$router.push({ path: "*" });
			}
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			const {
				nomeUsuarioCompleto

			} = JSON.parse(localStorage.params);
			this.userName = nomeUsuarioCompleto;
		},

		beforeMount () {
			this.optionsCustomer = this.customer.map((ele) => ({ value: ele.value, text: ele.text }));
		},
		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			async generarPDF () {
				await this.$nextTick();

				setTimeout(() => {
					this.$refs.html2Pdf.generatePdf();
				}, 300);
			},
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findCustomerSegment();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findCustomerSegment();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findCustomerSegment();
			},

			async findCustomerSegment () {
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const filters = {
					offset,
					limit,
					sortTable,
					...this.filtersSearch
				};

				this.responseResult = await this.customerService.reportCustomerSegment(filters) || {
					rows: [],
					count: 0
				};
				this.linhas = [];

				this.responseResult.rows.forEach((c, idx) => {
					const idCustomerPrevius = idx ? this.responseResult.rows[idx - 1].idCustomer : null;
					const isSameCustomer = Boolean(idCustomerPrevius === c.idCustomer);
					const balance = Number(c.amount) - Number(c.receivedAmount);

					this.linhas.push({
						idCustomer: c.idCustomer,
						noDetails: !c.numDoc,
						cols: [
							isSameCustomer ? "" : c.customerName || "",
							isSameCustomer ? "" : c.identityDocument || "",
							c.numDoc || "",
							formatterSimple(c.date),
							c.receivedDate ? formatterSimple(c.receivedDate) : formatterSimple(c.toReceiveDate),
							numberFormatted(c.amount),
							numberFormatted(c.receivedAmount || 0),
							numberFormatted(balance),
							(balance && Number(c.receivedAmount)) ? STATUS_RECEIVE.RENEGOTIATED : STATUS_RECEIVE[c.status]
						]
					});
				});

				this.pagination.count = this.responseResult.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async exportData (type) {
				try {
					const filters = {
						sortTable: this.sortTable,
						...this.filtersSearch
					};
					this.loading = true;
					this.loadPDF = false;
					this.title = "Estrato de Clientes";
					let data = {};
					if (this.responseResult.rows.length == this.responseResult.count) {
						data = { ...this.responseResult };
					} else {
						data = await this.customerService.reportCustomerSegment(filters) || {
							rows: [],
							count: 0
						};
					}

					const exportType = {
						pdf: ["customerName", "identityDocument", "numDoc", "date", "toReceiveDate", "amount", "receivedAmount", "balance", "status"],
						xlsx: ["Cliente", "CPF/CNPJ", "Documento", "Data", "Vence", "Valor", "Recebido", "Saldo Pendente", "Status"],
						csv: ["Cliente", "CPF/CNPJ", "Documento", "Data", "Vence", "Valor", "Recebido", "Saldo Pendente", "Status"]
					};

					this.rowsReport = [];
					this.totalAmount = 0;
					this.totalReceivedAmount = 0;

					let totalAmountCustomer = 0;
					let totalReceivedAmountCustomer = 0;

					data.rows.forEach((rec, idx) => {
						const amount = Number(rec.amount);
						const receivedAmount = Number(rec.receivedAmount);
						this.totalReceivedAmount += receivedAmount;

						const idCustomerPrevius = idx ? data.rows[idx - 1].idCustomer : null;
						const isSameCustomer = Boolean(idCustomerPrevius === rec.idCustomer);
						const balance = amount - receivedAmount;


						if (!isSameCustomer && idx !== 0) {
							this.rowsReport.push({
								class: "font-weight-bold",
								[exportType[type][0]]: "",
								[exportType[type][1]]: "",
								[exportType[type][2]]: "",
								[exportType[type][3]]: "",
								[exportType[type][4]]: "Totais cliente:",
								[exportType[type][5]]: numberFormatted(totalAmountCustomer),
								[exportType[type][6]]: numberFormatted(totalReceivedAmountCustomer),
								[exportType[type][7]]: numberFormatted(totalAmountCustomer - totalReceivedAmountCustomer)
							});

							this.totalAmount += totalAmountCustomer;
							totalAmountCustomer = 0;
							totalReceivedAmountCustomer = 0;
						}
						this.rowsReport.push({
							[exportType[type][0]]: !isSameCustomer && rec.customerName || "",
							[exportType[type][1]]: !isSameCustomer && rec.identityDocument || "",
							[exportType[type][2]]: rec.numDoc || "",
							[exportType[type][3]]: formatterSimple(rec.date),
							[exportType[type][4]]: formatterSimple(rec.receivedDate || rec.toReceiveDate),
							[exportType[type][5]]: numberFormatted(rec.amount),
							[exportType[type][6]]: numberFormatted(rec.receivedAmount || 0),
							[exportType[type][7]]: numberFormatted(balance),
							[exportType[type][8]]: (balance && Number(rec.receivedAmount)) ? STATUS_RECEIVE.RENEGOTIATED : STATUS_RECEIVE[rec.status]
						});

						totalAmountCustomer += amount;
						if (balance && !rec.createdOfIdToReceive && rec.receivedAmount)
							totalAmountCustomer -= balance;

						totalReceivedAmountCustomer += receivedAmount;

					});

					if (totalAmountCustomer) {
						this.rowsReport.push({
							class: "font-weight-bold",
							[exportType[type][0]]: "",
							[exportType[type][1]]: "",
							[exportType[type][2]]: "",
							[exportType[type][3]]: "",
							[exportType[type][4]]: "Totais cliente:",
							[exportType[type][5]]: numberFormatted(totalAmountCustomer),
							[exportType[type][6]]: numberFormatted(totalReceivedAmountCustomer),
							[exportType[type][7]]: numberFormatted(totalAmountCustomer - totalReceivedAmountCustomer)
						});

						this.totalAmount += totalAmountCustomer;
					}

					this.rowsReport.push({
						class: "font-weight-bold",
						[exportType[type][0]]: "",
						[exportType[type][1]]: "",
						[exportType[type][2]]: "",
						[exportType[type][3]]: "",
						[exportType[type][4]]: "Totais geral:",
						[exportType[type][5]]: numberFormatted(this.totalAmount),
						[exportType[type][6]]: numberFormatted(this.totalReceivedAmount),
						[exportType[type][7]]: numberFormatted(this.totalAmount - this.totalReceivedAmount)
					});

					if (type === "csv") {
						exportCSVFile(this.rowsReport, this.title);
						this.loading = false;
					} else if (type === "xlsx") {
						const worksheet = XLSX.utils.json_to_sheet(this.rowsReport);
						const workbook = XLSX.utils.book_new();
						XLSX.utils.book_append_sheet(workbook, worksheet, "pagina 1");
						XLSX.writeFile(workbook, `${this.title}.xlsx`);
						this.loading = false;
					} else {
						this.floatLayout = false;
						this.loadPDF = true;
						this.fields = [
							{ key: "customerName", label: "Cliente", style: { width: "45mm", "padding-left": "5px" } },
							{ key: "identityDocument", label: "CPF/CNPJ", style: { width: "26mm" } },
							{ key: "numDoc", label: "Documento", style: { width: "13mm" } },
							{ key: "date", label: "Data", style: { width: "14mm", "text-align": "right" } },
							{ key: "toReceiveDate", label: "Vence", style: { width: "20mm", "text-align": "right" } },
							{ key: "amount", label: "Valor", style: { width: "18mm", "text-align": "right" } },
							{ key: "receivedAmount", label: "Recebido", style: { width: "18mm", "text-align": "right" } },
							{ key: "balance", label: "Saldo Pendente", style: { width: "22mm", "text-align": "right"} },
							{ key: "status", label: "Status", style: { width: "18mm", "text-align": "left", "padding-left": "5px", "padding-right": "5px"} }
						];
						this.headerData = {
							date: dayjs().locale("pt-br").format("DD-MM-YYYY"),
							hour: dayjs().locale("pt-br").format("HH:mm:ss"),
							user: this.userName,
							qtdRows: this.rowsReport.length
						};

						await this.generarPDF();
						this.floatLayout = true;
					}
				} catch (e) {
					console.log(e);
					this.$swal({
						title: "Erro",
						text: `Falha ao exportar dados! - "${e.message}"`,
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "rgb(132, 170, 194)",
						confirmButtonText: "Ok"
					});
				} finally {
					this.loading = false;
				}
			},

			finishGeneratePdf () {
				this.loading = false;
			},

			async setFilterSearch (filtersSelected) {
				this.filtersSearch.idsCustomer = filtersSelected?.idsCustomer || [];
				this.filtersSearch.initDate = filtersSelected.initDate;
				this.filtersSearch.endDate = filtersSelected.endDate;

				this.closeFilters();
				await this.findCustomerSegment();
			},

			filterDropDownActive () {
				this.showFiltersForm = !this.showFiltersForm;
			},

			closeFilters () {
				this.showFiltersForm = false;
			}
		}
	};
</script>

<style scoped>
	.text-conta {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.label-conta {
		color: #696969 !important;
	}

	.toggle-conta {
		display: flex;
		margin-top: 7px;
		justify-content: center;
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 3rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.container-btn-print {
		margin-left: -10px;
		margin-top: -10px;
	}

	.container-modal-btn-print {
		margin-left: -5px;
		margin-top: -6px;
	}

	.add-button {
		width: 135;
		height: 43;
		font-family: 'Roboto Condensed Medium';
		background-color: #218838;
		color: #FFFFFF;
		font-size: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		padding: .75rem 1.5rem;
		border-style: none;
		margin-bottom: .5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.head-row {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: space-between;
		margin-top: -16px;
	}

	.text-head-row {
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: 'Roboto Condensed Bold';
		letter-spacing: -0.05em;
		font-size: 14px;
		color: #6C757D;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.responsive-filter-modal {
		display: flex;
		justify-content: space-evenly;
	}

	.filter-rows {
		width: 50%;
		padding: 1.25rem 0 1.25rem 1.25rem;
		font-size: 1.15rem;
	}
	.filter-rows-next {
		padding-left: 0.8rem;
		padding-right: 1.25rem;
	}

	@media (max-width: 768px) {
		.responsive-filter-modal {
			display: block;
		}
		.filter-rows {
			padding-left: 1.8rem;
			padding-right: 0;
			width: 100%;
		}
		.filter-rows-next {
			padding-top: 0;
			margin-top: -1rem;
		}

	}
</style>